/* eslint-disable */
const CHAT_NOW_MONITOR_PROVIDER_NOTIF = `Summer Health - You've been assigned a new conversation: %chat_url%`;

const WELCOME_SUMMER = `Welcome to Summer Health! You can text our doctors about any pediatric need, and we'll get back to you within ~60 minutes.

Things like:
🤒 An urgent medical concern
🤱 Newborn needs
🎓 A developmental milestone inquiry
✳️ COVID-19 questions

Whenever you're ready, send that first text. And don't forget to save our number in your phone.`;

const WELCOME_SUMMER_TIER_BASIC = `Welcome to Summer Health! Reach out to our pediatricians through your care hub on the web or mobile app.

You can access your care hub here:
https://care.summerhealth.com/home

Or download our mobile app here:
iOS: https://apps.apple.com/us/app/summer-health/id6470217630

Android: https://play.google.com/store/apps/details?id=com.summerhealth.care`;

const INVALID_PHONE = `Your phone number is not a registered phone number on Summer Health.

Please register here:
https://www.summerhealth.com`;

const SMS_DEPRECATED = `Thanks for reaching out to Summer Health, you can reach a provider by starting a chat in-app.`;

const INACTIVE_MEMBERSHIP = `Your Summer Health membership is currently not active.

You can access your account details here:
https://care.summerhealth.com/home`;

const CHILD_REQUIRED = `Before getting started, please register a child with your account, and then text us again. https://care.summerhealth.com/home`;

const INTAKE_INFORMATION = `Thanks for texting with Summer Health. One of our providers will be with you in the next few minutes. In the meantime, please feel free to share any additional information our doctor might need to treat your child.

👶 Specify the name of the child we are treating today
🩺 Medical history, medications, allergies or other important medical information
📸 We encourage photos and videos, where applicable
🚨 If this is an emergency, please dial 911`;

const SESSION_DENIED_BASIC_TIER = `You are on the basic plan. To reach a pediatrician, please initiate a chat request from your care hub.

Click here for care hub: https://care.summerhealth.com/home`;

const INTAKE_SESSION_OPEN = `We have now connected you to %provider_name%, they will be with you shortly. In the meantime:

💬 Share what questions or concerns you have
📸 Send photos and videos for personalized guidance
🚨 Call 911 if this is an emergency.`;

const INTAKE_SESSION_OPEN_MERIDIAN_HEALTH_PLAN = `We have now connected you to %provider_name%, they will be with you shortly. In the meantime:

📸 Please send a photo of your child before the conversation starts
💬 Share what questions or concerns you have
🚨 Call 911 if this is an emergency.`;

const GROUP_UNSUPPORTED = `Thanks for reaching Summer Health! We want to support your whole family at once. Unfortunately, because of carrier limitations, group messaging isn't currently supported. Feel free to text us back from a single registered phone number to speak with a doctor.`;

const PROVIDER_PAGE = `Summer Health - You've been assigned a new chat: %chat_url%`;

const PROVIDER_ROUTER_REROUTE = `Summer Health - The conversation will be re-assigned to a new provider.  Your status in %app_name% has been changed to “Unavailable”.  Please login to %app_name% again to provide care.`;

const PROVIDER_PAGE_REROUTE = `🚨🚨🚨 Summer Health - Your help is needed. A patient has been rerouted to you.  If you're available, please respond ASAP. 🚨🚨🚨`;

const PROVIDER_MADE_UNAVAILABLE = `Summer Health - You have been moved to “unavailable” in %app_name% because you have missed 3 conversations in a row.  Please log in to %app_name% and make yourself available when you are able to provide care: %chat_url%`;

const PROVIDER_IDLE_REMINDER = `Summer Health: You have an open conversation in %app_name%. A caregiver last sent a message more than 15 minutes ago and you have not yet responded. Please respond to continue the conversation or close the conversation and document it in CareOS.`;

const PROVIDER_IDLE_FALLBACK_PAGE = `Summer Health: %conversationId% has been idle for 60 minutes with %assignedProvider%. Please review and determine if the conversation should be closed: %chat_url%`;

const PROVIDER_IDLE_MESSAGE_PAGE = `Summer Health: A caregiver has sent you a new message that needs your attention.  Log into to %app_name% to ensure they receive care.`;

const PROVIDER_CONVERSATION_CLOSED = `You closed a conversation started at %conversation_started_at% with %caregiver_name%. Please log in to CareOS to complete a visit note: %encounter_link%`;

const PROVIDER_NEW_CHAT_REQUEST = `Summer Health - You've been assigned a Chat Request task: %task_url%`;

const SESSION_CLOSED = `✅ Thanks for texting us today! ✅
The physician has left the chat. Any further messages will begin a new conversation.

Your visit note will be available on your Summer Health account soon. Reach back out anytime! ☀️`;

const INTERNAL_SESSION_CLOSED = `Provider has ended the chat, tap on follow up if you have more questions.`;

const FIRST_SESSION_CLOSED = `✅ Thanks for texting us today! ✅
The physician has left the chat. Any further messages will begin a new conversation.

Your visit note will be available on your Summer Health account soon. Reach back out anytime! ☀️`;

const SESSION_WAIT_TIMER_1 = `One of our providers will be with you shortly. Stay tuned! When they enter, they will introduce themselves and ask you about your child. If you have any questions, please feel free to email us at help@summerhealth.com.`;

const SESSION_WAIT_TIMER_2 = `It's taking longer than usual in your region, but luckily we've assigned a provider to your case and you should hear from us in a few minutes. Since we took longer than 60 minutes to respond, we'll be applying a free month to your account for next month. Thanks for your patience.`;

const SESSION_WAIT_TIMER_2_ANNUAL = ` It's taking longer than usual in your region, but luckily we've assigned a provider to your case and you should hear from us in a few minutes. Thank you for your patience!`;

const SESSION_WAIT_TIMER_1_PREMIUM = `It's taking longer than usual in your region, but luckily we've assigned a provider to your case and you should hear from us in a few minutes.

Since we took longer than 5 minutes to respond, we'll take 50% off the price of your subscription for the next two months (terms apply). Thanks for your patience.`;

const SESSION_WAIT_TIMER_2_MEDICAID = `It's taking longer than usual in your region, but luckily we've assigned a provider to your case and you should hear from us in a few minutes. Thank you for your patience!`;

const SPONSORED_CAREGIVER_INVITE = `%account_holder_name% has invited you to Summer Health, where you can help manage %patient_name%'s pediatric care.

Sign up at: https://care.summerhealth.com/signup/profile`;

const SPONSORED_CAREGIVER_INVITE_EXISTING_USER = `%account_holder_name% has invited you to Summer Health, where you can help manage %patient_name%'s pediatric care.

Accept the invitation by logging in at:
https://care.summerhealth.com/signup/welcome`;

const SPONSORED_CAREGIVER_INVITE_RESOLVED_ACCEPTED = `%sponsored_caregiver_name% has accepted your invitation to be the caregiver for %accepted_patient_name%`;

const SPONSORED_CAREGIVER_INVITE_RESOLVED_DECLINED = `%sponsored_caregiver_name% has declined your invitation to be the caregiver for %declined_patient_name%`;

const SPONSORED_CAREGIVER_INVITE_RESOLVED_BOTH = `%sponsored_caregiver_name% has accepted your invitation to be the caregiver for %accepted_patient_name%, and declined to be caregiver for %declined_patient_name%`;

const SUBSCRIPTION_CANCELED = `Your subscription is canceled, if you would like to reach our pediatricians, you can request to restart your subscription by emailing us at help@summerhealth.com`;

const SUBSCRIPTION_PAUSED = `Your subscription is on pause, if you want to reach our pediatricians, you can resume your subscription by clicking on Manage Subscription here: https://care.summerhealth.com/account/billing`;

const CARE_TEAM_ROUTING = `We are connecting you to %provider_name%, they will be with you shortly. In the meantime:

💬 Share what questions or concerns you have
📸 Send photos and videos for personalized guidance
🚨 Call 911 if this is an emergency.`;

const CARE_TEAM_ROUTING_FALLBACK = `%provider_name% is not available, but we are connecting you to the next available provider now. In the meantime:

💬 Share what questions or concerns you have
📸 Send photos and videos for personalized guidance
🚨 Call 911 if this is an emergency.`;

const CARE_TEAM_ROUTING_MERIDIAN_HEALTH_PLAN = `We are connecting you to %provider_name%, they will be with you shortly. In the meantime:

📸 Please send a photo of your child before the conversation starts
💬 Share what questions or concerns you have
🚨 Call 911 if this is an emergency.`;

const INTAKE_UNASSIGNED_SESSION_OPENED = `We have started a new chat for you and a provider will be with you soon to answer your question.
%title%
%question%`;

const INTAKE_UNASSIGNED_SESSION_OPENED_MERIDIAN_HEALTH_PLAN = `We have started a new chat for you and a provider will be with you soon to answer your question.

📸 Please send a photo of your child before the conversation starts

%title%
%question%`;

const INTAKE_ASSIGNED_SESSION_OPENED = `We have now connected you to %provider_name%, they will be with you shortly to answer your question.
%title%
%question%`;

const INTAKE_ASSIGNED_SESSION_OPENED_MERIDIAN_HEALTH_PLAN = `We have now connected you to %provider_name%, they will be with you shortly to answer your question.

📸 Please send a photo of your child before the conversation starts

%title%
%question%`;

const INSTALL_APP_TEXT = `Install the Summer Health app for easy access to your care team & plan.

iOS: https://apps.apple.com/us/app/summer-health/id6470217630

Android: https://play.google.com/store/apps/details?id=com.summerhealth.care`;

const SPECIALIST_ROUTING = `We are connecting you to %specialist%, they will be with you shortly. In the meantime:

💬 Share what questions or concerns you have
📸 Send photos and videos for personalized guidance
🚨 Call 911 if this is an emergency.`;

const CREATE_SPECIALIST_CHAT_REQUEST = `Our {specialist} is not available at the moment. would you like to wait {specialist}'s response?

Reply “yes” for the specialist, “no” for the pediatrician.`;

const SPECIALIST_CHAT_REQUEST_CREATED = `Created chat request for {specialist}. Our {specialist} will be with you when it's available.`;

const PROVIDER_PAGE_TRANSFER = `Summer Health - You've been transferred a chat: %chat_url%`;

const AUTOMATED_CARE_SESSION_CLOSED = 'Please text us anytime!';

const PAYG_PRICE_CONFIRMATION =
  'Your visit today will cost %price%. Reply YES to continue or NO to cancel.';
const PAYG_PAYMENT_AUTHORIZED =
  'Payment authorized. Connecting you with a provider...';
const PAYG_PAYMENT_FAILED =
  'Payment failed. Please update your card at %updateCardUrl%. Reply UPDATED when done.';
const PAYG_PAYMENT_UPDATED = 'Thanks! Let me try again...';
const PAYG_SESSION_CANCELLED =
  "No problem. Message us when you're ready for a visit.";
const PAYG_SESSION_TIMEOUT =
  'Session cancelled due to timeout. Message us when ready.';
const PAYG_RETRY_EXHAUSTED =
  "We're having trouble processing your payment. Please contact support.";
const PAYG_PROVIDER_INITIATED =
  'This session was started by your provider. No charge will apply.';
const PAYG_PAYMENT_LINK_REQUEST =
  'To start your visit, please authorize your payment method for %amount%. Click here to continue: %paymentLink%';
const PAYG_PAYMENT_SUCCESS =
  'Payment method authorized successfully! Connecting you with a provider...';
const PAYG_WAITING_PAYMENT =
  "We're waiting for you to complete the payment authorization. Please click the link above.";
const PAYG_CARD_FAILED_ADD_NEW =
  'Your card on file was declined. Please add a new payment method to continue: %paymentLink%';
const PAYG_TRY_AGAIN_PROMPT =
  'Would you like to try adding your payment method again? Reply YES to try again or NO to cancel.';

const PAYG_EMAIL_RECEIPT_SUBJECT = 'Your Summer Health Visit Receipt';
const PAYG_EMAIL_RECEIPT_BODY =
  'Thank you for your visit on %visitDate%. Amount charged: %amount%';
const PAYG_EMAIL_FAILED_SUBJECT = 'Payment Failed - Action Required';
const PAYG_EMAIL_FAILED_BODY =
  "We couldn't process your payment for today's visit. Please update your payment method: %updateCardUrl%";

const INSURANCE_UNVERIFIED_COVERAGE_DISCLAIMER = `Your insurance coverage is not yet verified. We will try our best to work with your insurance, but you may be responsible for charges for this session. Do you agree to proceed?`;
const INSURANCE_COMMERCIAL_COVERAGE_DISCLAIMER = `Your insurance is active and covers this session, standard benefits apply, but charges like co-pay or coinsurance may apply. Do you agree to proceed?`;
const INSURANCE_TROUBLE_CONFIRMING_DISCLAIMER = `We're having trouble confirming your response. We've closed this chat for now. If you still need help, please reach out to support at help@summerhealth.com or start a new chat.`;
const INSURANCE_DISCLAIMER_DECLINED = `We understand you don't want to proceed with this visit. If you have any questions about your coverage or our services, please contact support at help@summerhealth.com.`;

const SUNNY_PROVIDER_ENGAGED = `Your provider is joining now, I'll make sure to tell them what we discussed.`;

const SESSION_OUTSIDE_AVAILABLE_HOURS = `Summer Health providers are currently offline and unavailable. You will not receive a response to this message. Please reach out again between the hours of 9am and 9pm ET, weekdays. Thank you for understanding!`;

const DISCONTINUED_STATE = `Hi there - this is an automated message. As of January 5th, we no longer operate care in your state. We apologize for the inconvenience. Email help@summerhealth.com with any questions.`;

export const systemMessages: Record<string, string> = {
  CHAT_NOW_MONITOR_PROVIDER_NOTIF,
  WELCOME_SUMMER,
  WELCOME_SUMMER_TIER_BASIC,
  INVALID_PHONE,
  SMS_DEPRECATED,
  INACTIVE_MEMBERSHIP,
  CHILD_REQUIRED,
  INTAKE_INFORMATION,
  SESSION_DENIED_BASIC_TIER,
  INTAKE_SESSION_OPEN,
  INTAKE_SESSION_OPEN_MERIDIAN_HEALTH_PLAN,
  GROUP_UNSUPPORTED,
  PROVIDER_PAGE,
  PROVIDER_PAGE_REROUTE,
  PROVIDER_PAGE_TRANSFER,
  PROVIDER_ROUTER_REROUTE,
  PROVIDER_MADE_UNAVAILABLE,
  PROVIDER_IDLE_REMINDER,
  PROVIDER_IDLE_MESSAGE_PAGE,
  PROVIDER_IDLE_FALLBACK_PAGE,
  PROVIDER_CONVERSATION_CLOSED,
  PROVIDER_NEW_CHAT_REQUEST,
  SESSION_CLOSED,
  FIRST_SESSION_CLOSED,
  INTERNAL_SESSION_CLOSED,
  SESSION_WAIT_TIMER_1,
  SESSION_WAIT_TIMER_2,
  SESSION_WAIT_TIMER_2_ANNUAL,
  SESSION_WAIT_TIMER_1_PREMIUM,
  SESSION_WAIT_TIMER_2_MEDICAID,
  SPONSORED_CAREGIVER_INVITE,
  SPONSORED_CAREGIVER_INVITE_EXISTING_USER,
  SPONSORED_CAREGIVER_INVITE_RESOLVED_ACCEPTED,
  SPONSORED_CAREGIVER_INVITE_RESOLVED_DECLINED,
  SPONSORED_CAREGIVER_INVITE_RESOLVED_BOTH,
  SUBSCRIPTION_CANCELED,
  SUBSCRIPTION_PAUSED,
  CARE_TEAM_ROUTING,
  CARE_TEAM_ROUTING_FALLBACK,
  CARE_TEAM_ROUTING_MERIDIAN_HEALTH_PLAN,
  INTAKE_UNASSIGNED_SESSION_OPENED,
  INTAKE_UNASSIGNED_SESSION_OPENED_MERIDIAN_HEALTH_PLAN,
  INTAKE_ASSIGNED_SESSION_OPENED,
  INTAKE_ASSIGNED_SESSION_OPENED_MERIDIAN_HEALTH_PLAN,
  INSTALL_APP_TEXT,
  SPECIALIST_ROUTING,
  CREATE_SPECIALIST_CHAT_REQUEST,
  SPECIALIST_CHAT_REQUEST_CREATED,
  AUTOMATED_CARE_SESSION_CLOSED,
  PAYG_PRICE_CONFIRMATION,
  PAYG_PAYMENT_AUTHORIZED,
  PAYG_PAYMENT_FAILED,
  PAYG_PAYMENT_UPDATED,
  PAYG_SESSION_CANCELLED,
  PAYG_SESSION_TIMEOUT,
  PAYG_RETRY_EXHAUSTED,
  PAYG_PROVIDER_INITIATED,
  PAYG_PAYMENT_LINK_REQUEST,
  PAYG_PAYMENT_SUCCESS,
  PAYG_WAITING_PAYMENT,
  PAYG_CARD_FAILED_ADD_NEW,
  PAYG_TRY_AGAIN_PROMPT,
  PAYG_EMAIL_RECEIPT_SUBJECT,
  PAYG_EMAIL_RECEIPT_BODY,
  PAYG_EMAIL_FAILED_SUBJECT,
  PAYG_EMAIL_FAILED_BODY,
  INSURANCE_UNVERIFIED_COVERAGE_DISCLAIMER,
  INSURANCE_COMMERCIAL_COVERAGE_DISCLAIMER,
  INSURANCE_TROUBLE_CONFIRMING_DISCLAIMER,
  INSURANCE_DISCLAIMER_DECLINED,
  SUNNY_PROVIDER_ENGAGED,
  SESSION_OUTSIDE_AVAILABLE_HOURS,
  DISCONTINUED_STATE,
};
